import WorkLogForm from "../workLogForm";
//--------------------------------------------------------------------------------------------
export default function WorkplaceViolenceIncidentReportForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Date of incident", type: "text", required: true}, 
        {title: "Time of incident", type: "date", required: true},

        {title: "Employee Name", type: "text", required: true}, // auto or select
        {title: "Title", type: "text", required: true},

        {title: "Names of other affected employees", type: "text", required: true}, // multiSelect
        
        {title: "Department / Unit", type: "text", required: true}, // auto

        {title: "Work Location", type: "text", required: true},
        {title: "Work Phone", type: "text", required: true}, // phone

        {title: "Location of Incident", type: "text", required: true},
        {title: "Were there any injuries?", type: "radio", required: true},

        {title: "Extent of injuries", type: "textarea", required: true},

        {title: "Was medical treatment required?", type: "radio", required: true},
        
        {title: "Was medical treatment required (Explain)", type: "text"},

        {title: "Was the employee hospitalized?", type: "radio", required: true},

        {title: "Was the employee hospitalized (Explain)", type: "text"},

        {title: "Description of incident", type: "select", options: ["Physical abuse", "Verbal abuse", "Threat", "Other"], required: true},

        {title: "Description of incident (Other)", type: "text"},

        {title: "Was the assailant a?", type: "select", options: ["Client or Patient", "Co-worker or Supervisor", "Intimate partner or Loved one", "Other"], required: true},

        {title: "Was the assailant a (Other)", type: "text"},

        {title: "Were the Police notified?", type: "radio", required: true},

        {title: "Was the assailant notified?", type: "radio", required: true},
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            prefix = {<p>This form should be completed immediately following a workplace violence incident. Affected employees should be given assistance to complete all fields, if required. Once completed, make a copy of the form for all affected employees and return the original to the employee's supervisor.</p>}
            items = {items}
            {...rest}
        />
    )    
}